import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import Login from './pages/login';
import ErrorPage from './pages/ErrorPage'
// import FavoriteDetail from './pages/FavoriteDetail';

function App() {
  useEffect(() => {
    console.log('[DEBUG] userId:', process.env.REACT_APP_DEFAULT_USERID);
    console.log('[DEBUG] apiUrl:', process.env.REACT_APP_API_URL);
  }, []);

  return (
    <Router>
      <nav>
        <Link to="/">Home</Link> | <Link to="/about">About</Link>
      </nav>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/error" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
}

export default App;
